import { render, staticRenderFns } from "./ChangeOwnerDialog.vue?vue&type=template&id=70edd2dc&"
import script from "./ChangeOwnerDialog.vue?vue&type=script&lang=js&"
export * from "./ChangeOwnerDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports